export class ExtendableError extends Error {}
